<section class="table-properties" aria-label="Repeated table properties">
  <h4>Repeated table</h4>
  @if (validationError) {
    <p class="binding-warning" role="alert">{{ validationError }}</p>
  }
  @if (contextEnabled) {
    <label
      >Data list<select
        uiControl
        name="table-list"
        [ngModel]="block.source ?? ''"
        (ngModelChange)="changeList($event)"
        [disabled]="disabled || !lists.length"
      >
        @if (!selectedList) {
          <option [value]="block.source ?? ''" data-unavailable="list">
            Unavailable list: {{ block.source || "Unspecified" }}
          </option>
        }
        @for (list of lists; track list.code) {
          <option [value]="list.code">{{ list.label }}</option>
        }
      </select></label
    >
    @if (!selectedList) {
      <p class="binding-warning" role="status">
        Choose an available registered list to repair this table. Existing
        bindings are preserved until you change them.
      </p>
    }
  } @else {
    @if (block.source === "notice.items") {
      <p class="table-source">Data list: Synthetic notice items</p>
    } @else {
      <p class="binding-warning" data-unavailable="list" role="status">
        Unavailable list: {{ block.source || "Unspecified" }}. This composition
        supports Synthetic notice items only. Inspect Fields to repair the
        retained source before saving.
      </p>
    }
  }
  <p class="table-guidance">Column widths are relative weights from 1 to 4.</p>
  @for (column of columns; track column.id; let index = $index) {
    <fieldset
      class="table-column"
      [attr.data-column-id]="column.id"
      [disabled]="disabled"
    >
      <legend>Column {{ index + 1 }}</legend>
      <label
        >Heading<input
          uiControl
          data-column-control="heading"
          [name]="'table-heading-' + column.id"
          [attr.aria-label]="'Heading for column ' + (index + 1)"
          maxlength="80"
          [ngModel]="column.label"
          (ngModelChange)="changeText(column, 'label', $event)"
      /></label>
      <label
        >Field<select
          uiControl
          [name]="'table-field-' + column.id"
          [attr.aria-label]="'Field for column ' + (index + 1)"
          [ngModel]="column.field"
          (ngModelChange)="changeText(column, 'field', $event)"
          [disabled]="disabled || !fields.length"
        >
          @if (!knownField(column)) {
            <option [value]="column.field" data-unavailable="field">
              Unavailable field: {{ column.field || "Unspecified" }}
            </option>
          }
          @for (field of fields; track field.code) {
            <option [value]="field.code">{{ field.label }}</option>
          }
        </select></label
      >
      @if (contextEnabled) {
        <label
          >Format<select
            uiControl
            [name]="'table-format-' + column.id"
            [attr.aria-label]="'Format for column ' + (index + 1)"
            [ngModel]="formatSelectionValue(column)"
            (ngModelChange)="changeText(column, 'format', $event)"
            [disabled]="disabled || !formats(column).length"
          >
            <option value="">Default</option>
            @if (!knownFormat(column)) {
              <option
                [ngValue]="formatSelectionValue(column)"
                data-unavailable="format"
              >
                {{
                  column.format
                    ? "Unavailable: " + column.format
                    : "Unavailable: empty format"
                }}
              </option>
            }
            @for (format of formats(column); track format) {
              <option [value]="format">{{ format }}</option>
            }
          </select></label
        >
      }
      @if (!knownField(column) || (contextEnabled && !knownFormat(column))) {
        <p class="binding-warning" role="status">
          This column has an unavailable binding. Choose a registered field and
          format before saving.
        </p>
      }
      @if (!contextEnabled && column.format !== undefined) {
        <p class="binding-warning" data-unavailable="format" role="status">
          Unavailable format: {{ column.format || "Unspecified" }}. This
          composition does not support column formats. Inspect Fields to repair
          the retained source before saving.
        </p>
      }
      <label
        >Width<input
          uiControl
          type="number"
          min="1"
          max="4"
          step="any"
          [name]="'table-width-' + column.id"
          [attr.aria-label]="'Width for column ' + (index + 1)"
          [ngModel]="column.width"
          (ngModelChange)="changeWidth(column, $event)"
      /></label>
      <div class="column-actions">
        <button
          uiButton="secondary"
          type="button"
          [attr.aria-label]="'Move column ' + (index + 1) + ' left'"
          [disabled]="disabled || index === 0"
          (click)="moveColumn(column, -1)"
        >
          Left
        </button>
        <button
          uiButton="secondary"
          type="button"
          [attr.aria-label]="'Move column ' + (index + 1) + ' right'"
          [disabled]="disabled || index === columns.length - 1"
          (click)="moveColumn(column, 1)"
        >
          Right
        </button>
        <button
          uiButton="secondary"
          type="button"
          [attr.aria-label]="'Remove column ' + (index + 1)"
          [disabled]="disabled || columns.length <= 2"
          (click)="removeColumn(column)"
        >
          Remove
        </button>
      </div>
    </fieldset>
  }
  <button
    uiButton="secondary"
    type="button"
    [disabled]="!canAddColumn"
    (click)="addColumn()"
  >
    Add column
  </button>
  <p class="visually-hidden" role="status" aria-live="polite">
    {{ announcement }}
  </p>
</section>
